// Engine Reference Tags

export enum SecurityTag {
  LocalUserSecurity = 'LocalUserSecurity',
  None = 'None',
  NotAccessibleSecurity = 'NotAccessibleSecurity',
  PluginSecurity = 'PluginSecurity',
  RobloxScriptSecurity = 'RobloxScriptSecurity',
  RobloxSecurity = 'RobloxSecurity',
  RobloxEngineSecurity = 'RobloxEngineSecurity',
}

export enum ApiTag {
  CanYield = 'CanYield',
  CustomLuaState = 'CustomLuaState',
  Deprecated = 'Deprecated',
  Hidden = 'Hidden',
  NotBrowsable = 'NotBrowsable',
  NotCreatable = 'NotCreatable',
  NotReplicated = 'NotReplicated',
  NotScriptable = 'NotScriptable',
  NoYield = 'NoYield',
  PlayerReplicated = 'PlayerReplicated',
  ReadOnly = 'ReadOnly',
  Service = 'Service',
  Settings = 'Settings',
  UserSettings = 'UserSettings',
  Yields = 'Yields',
  OpenCloudSecurity = 'OpenCloudSecurity',
  PluginSecurity = 'PluginSecurity',
}

export enum ThreadSafetyTag {
  ReadSafe = 'ReadSafe',
  Safe = 'Safe',
  Unsafe = 'Unsafe',
}

export type EngineTag = SecurityTag | ThreadSafetyTag | ApiTag;

// Open Cloud Reference Tags

export enum CloudTag {
  OutputOnly = 'OutputOnly',
  InputOnly = 'InputOnly',
  Required = 'Required',
  Optional = 'Optional',
  Immutable = 'Immutable',
  Deprecated = 'Deprecated',
  Beta = 'Beta',
  Experimental = 'Experimental',
  Stable = 'Stable',
}

export type ReferenceClass = 'engine' | 'cloud';
